import isArray from 'lodash/isArray';
import extend from 'lodash/extend';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ngHelper, currencyParser, IMultiUrlImage } from '@cakeiteasy/web-utils';
import { ISelectItem } from '@cakeiteasy/web-ui';

@Component({
  standalone: false,
  selector: 'cake-extra-products-section',
  templateUrl: './cake-extra-products-section.component.html'
})
export class CakeExtraProductsSectionComponent implements OnChanges {
  @Input() disabled: boolean;
  @Input() products: any;
  @Input() group: any;
  @Input() selectedProducts: any;
  @Input() currency = 'kr';

  @Output() onSelect = new EventEmitter<any>();

  public selectItems: ISelectItem[];

  public pic: {
    show: boolean,
    pictureId: number,
    offsetTop: number,
    image: IMultiUrlImage
  } = { show: false, offsetTop: 0, pictureId: 0, image: null };

  public onProductsSelect(products) {
    if (isArray(products)) {
      this.onSelect.emit(products);
    } else {
      this.onSelect.emit([products]);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'products', (products) => {
      this.selectItems = products.map((p) => {
        return {
          label: p.name,
          priceLabel: (p.hidePrice || p.price < 1)  ? '' : currencyParser(p.price, this.currency),
          value: p,
          ref: p,
          type: p.type,
          isDefaultValue: p.id === 0
        };
      });
    });
  }

  public imageSelect(pictureData) {
    this.pic = extend({ show: true }, pictureData);
  }
}
